import type { UIMessage } from 'ai';

/** Agent ``POST /v2/chat/stream`` rejects payloads with more than 50 UI messages. */
export const AGENT_V2_CHAT_STREAM_MAX_MESSAGES = 50;

/** Keep the most recent messages so long restored threads can still send new turns. */
export function truncateAgentV2StreamMessages<UI_MESSAGE extends UIMessage>(
  messages: readonly UI_MESSAGE[],
  max = AGENT_V2_CHAT_STREAM_MAX_MESSAGES
): UI_MESSAGE[] {
  if (messages.length <= max) {
    return [...messages];
  }
  return messages.slice(-max);
}

type PrepareAgentV2StreamSendMessagesRequestInput<UI_MESSAGE extends UIMessage> = {
  id: string;
  messages: UI_MESSAGE[];
  body: Record<string, unknown> | undefined;
  trigger: 'submit-message' | 'regenerate-message';
  messageId: string | undefined;
};

/** AI SDK transport hook: merge Kin stream body fields and cap ``messages`` for agent validation. */
export function prepareAgentV2StreamSendMessagesRequest<UI_MESSAGE extends UIMessage>({
  id,
  messages,
  body,
  trigger,
  messageId,
}: PrepareAgentV2StreamSendMessagesRequestInput<UI_MESSAGE>) {
  return {
    body: {
      ...body,
      id,
      messages: truncateAgentV2StreamMessages(messages),
      trigger,
      messageId,
    },
  };
}
